// Modal store timeouts
export const DOWNLOAD_MODAL_STORE_OPEN_TIMEOUT = 500;
export const DOWNLOAD_MODAL_STORE_HIGHLIGHT_TIMEOUT = 500;

// Index constants
export const FIRST_ELEMENT_INDEX = 0;
export const FIRST_CHAR = 0;
export const LAST_CHAR = 4;

// Toast timeout
export const TOAST_TIMEOUT = 1500;

// Sort constants
export const SORT_A_FIRST = -1;

